import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { collection, doc, getDoc, getDocs, query, where, updateDoc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import UserNav from '../../components/navbar/user-nav';
import FooterTop from '../../components/footer-top';
import Footer from '../../components/footer';
import Breadcrumb from '../../components/Breadcrumb';

export default function VerAfiliadoAdmin() {
  const { id } = useParams<{ id: string }>();
  const [afiliado, setAfiliado] = useState<any>(null);
  const [inmobiliariaNombre, setInmobiliariaNombre] = useState<string>('Sin asignar');
  const [propiedades, setPropiedades] = useState<any[]>([]);
  const [reseñas, setReseñas] = useState<any[]>([]);
  const [creditos, setCreditos] = useState(0);
  const [talleres, setTalleres] = useState<any[]>([]);
  const [talleresCompletados, setTalleresCompletados] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        setLoading(false);
        return;
      }

      try {
        // Obtener datos del afiliado
        const docRef = doc(db, 'asesor', id);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) {
          console.error('Afiliado no encontrado:', id);
          setLoading(false);
          return;
        }
        const data = docSnap.data();
        setAfiliado({ id: docSnap.id, ...data });

        // ✅ CORREGIDO: Buscar inmobiliaria usando doc.id
        if (data.inmobiliaria_doc_ids && Array.isArray(data.inmobiliaria_doc_ids) && data.inmobiliaria_doc_ids.length > 0) {
          try {
            const inmobiliariaDocId = data.inmobiliaria_doc_ids[0];

            const inmoDocRef = doc(db, 'inmobiliaria', inmobiliariaDocId);
            const inmoSnap = await getDoc(inmoDocRef);

            if (inmoSnap.exists()) {
              setInmobiliariaNombre(inmoSnap.data().nombre || 'Sin nombre');
            } else {
              console.log('No se encontró inmobiliaria con doc.id:', inmobiliariaDocId);
              setInmobiliariaNombre('Inmobiliaria no encontrada');
            }
          } catch (error) {
            console.error('Error buscando inmobiliaria:', error);
            setInmobiliariaNombre('Error al cargar inmobiliaria');
          }
        }

        // ✅ CORREGIDO: Buscar propiedades usando doc.id del asesor
        if (docSnap.id) {
          try {
            const propsQuery = query(
              collection(db, 'propiedades'),
              where('asesor_doc_ids', 'array-contains', docSnap.id), // ✅ doc.id del asesor
              where('activo', '==', true)
            );
            const snapProps = await getDocs(propsQuery);
            const props = snapProps.docs.map(p => ({ id: p.id, ...(p.data() as any) }));
            setPropiedades(props);
            console.log(`Propiedades encontradas para ${data.nombre}:`, props.length);
          } catch (error) {
            console.error('Error cargando propiedades:', error);
            setPropiedades([]);
          }
        } else {
          setPropiedades([]);
        }

        // Buscar reseñas
        if (data.asesor_id) {
          try {
            const calQuery = query(
              collection(db, 'calificacion'), 
              where('perfil_id', '==', data.asesor_id), 
              where('estatus', '==', 'aprobada')
            );
            const calSnap = await getDocs(calQuery);
            const calData = calSnap.docs.map(d => d.data());
            setReseñas(calData);
          } catch (error) {
            console.error('Error cargando reseñas:', error);
            setReseñas([]);
          }
        }

        // Buscar talleres e inscripciones usando doc.id (siguiendo el enfoque de dashboard)
        const perfilDocId = docSnap.id;
        if (perfilDocId) {
          try {
            console.log('🔍 Buscando inscripciones para perfil doc.id:', perfilDocId);
            const inscQuery = query(
              collection(db, 'inscripcion'),
              where('perfil_id', '==', perfilDocId)
            );
            const snapInscripcion = await getDocs(inscQuery);
            let totalCreditos = 0;

            const talleresData = await Promise.all(
              snapInscripcion.docs.map(async (docSnap) => {
                const inscripcion = docSnap.data();
                const inscripcionId = docSnap.id;

                // ✅ Usar taller_doc_id (doc.id de Firestore) en lugar de taller_id (legacy)
                const tallerDocId = inscripcion.taller_doc_id || inscripcion.taller_id;
                if (!tallerDocId) {
                  console.warn('Inscripción sin taller_doc_id:', inscripcionId);
                  return null;
                }

                const tallerRef = doc(db, 'taller', tallerDocId);
                const tallerSnap = await getDoc(tallerRef);
                const tallerInfo = tallerSnap.exists() ? tallerSnap.data() : null;

                let creditos = 0;
                let estatus = 'Sin empezar';

                if (inscripcion.completado) {
                  estatus = 'Listo';
                  if (typeof inscripcion.creditos === 'number') {
                    creditos = inscripcion.creditos;
                  } else if (tallerInfo && typeof tallerInfo.creditos === 'number') {
                    creditos = tallerInfo.creditos;
                    try {
                      await updateDoc(doc(db, 'inscripcion', inscripcionId), { creditos });
                    } catch (err) {
                      console.warn('No se pudo actualizar inscripción:', err);
                    }
                  }
                  totalCreditos += creditos;
                } else if (inscripcion.progreso) {
                  estatus = 'En progreso';
                }

                return tallerInfo
                  ? {
                      ...tallerInfo,
                      estatus
                    }
                  : null;
              })
            );

            const talleresValidos = talleresData.filter(Boolean);
            setTalleres(talleresValidos);

            // Contar solo talleres completados para "Talleres Asistidos" (siguiendo el enfoque de dashboard)
            const completados = talleresValidos.filter((t: any) => t && t.estatus === 'Listo');
            setTalleresCompletados(completados.length);

            console.log(`📊 Talleres totales: ${talleresValidos.length}, Completados: ${completados.length}, Créditos: ${totalCreditos}`);

            setCreditos(totalCreditos);
          } catch (error) {
            console.error('Error cargando talleres:', error);
            setTalleres([]);
            setTalleresCompletados(0);
            setCreditos(0);
          }
        }
        
      } catch (error) {
        console.error('Error cargando datos del afiliado:', error);
        setInmobiliariaNombre('Error al cargar');
        setPropiedades([]);
        setReseñas([]);
        setTalleres([]);
        setTalleresCompletados(0);
        setCreditos(0);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // Calcular promedio de calificación
  // Si hay reseñas aprobadas, usar el promedio de estrellas (1-5)
  // Si no hay reseñas pero existe calificacion en el perfil (0-100), convertir a escala 1-5
  const promedioCalificacion = reseñas.length > 0
    ? (reseñas.reduce((acc: number, r: any) => acc + (r.estrellas || 0), 0) / reseñas.length).toFixed(1)
    : afiliado?.calificacion
      ? (afiliado.calificacion / 20).toFixed(1)
      : 'N/A';

  const getBadge = (text: string, color: string) => (
    <span className={`badge bg-${color} ms-2`}>{text}</span>
  );

  const getColorEstatus = (estatus: string) => {
    switch (estatus) {
      case 'Sin empezar': return 'secondary';
      case 'En progreso': return 'warning';
      case 'Listo': return 'success';
      default: return 'light';
    }
  };

  if (loading) {
    return (
      <div className="container mt-5">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
          <p className="mt-3">Cargando datos del afiliado...</p>
        </div>
      </div>
    );
  }

  if (!afiliado) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          <h4>Afiliado no encontrado</h4>
          <p>No se pudo encontrar el afiliado con ID: {id}</p>
          <button className="btn btn-primary" onClick={() => navigate('/admin-afiliado')}>
            Regresar a lista de afiliados
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <UserNav />
      <div className="container py-5">
        <Breadcrumb
          items={[
            { label: 'Dashboard', path: '/admin-dashboard' },
            { label: 'Administración de Afiliados', path: '/admin-afiliado' },
            { label: afiliado.nombre }
          ]}
        />
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>
            <i className="fas fa-user-tie me-2 text-primary"></i>
            {afiliado.nombre}
          </h2>
        </div>

        <div className="row">
          <div className="col-md-4">
            <div className="card">
              <div className="card-header">
                <h5><i className="fas fa-user me-2"></i>Perfil</h5>
              </div>
              <div className="card-body text-center">
                {afiliado.foto ? (
                  <img
                    src={afiliado.foto}
                    alt={afiliado.nombre}
                    className="img-fluid rounded-circle mb-3"
                    style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                  />
                ) : (
                  <div
                    className="bg-secondary rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ width: '150px', height: '150px' }}
                  >
                    <i className="fas fa-user fa-4x text-white"></i>
                  </div>
                )}
                <h5>{afiliado.nombre}</h5>
                <p className="text-muted">{afiliado.especialidad || 'Asesor Inmobiliario'}</p>

                {/* Redes Sociales */}
                {(afiliado.redes?.facebook || afiliado.redes?.instagram || afiliado.sitio_web) && (
                  <div className="mt-3">
                    <h6>Redes Sociales</h6>
                    <div className="d-flex justify-content-center gap-2">
                      {afiliado.redes?.facebook && (
                        <a href={afiliado.redes.facebook} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                          <i className="fab fa-facebook"></i>
                        </a>
                      )}
                      {afiliado.redes?.instagram && (
                        <a href={afiliado.redes.instagram} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-danger">
                          <i className="fab fa-instagram"></i>
                        </a>
                      )}
                      {afiliado.sitio_web && (
                        <a href={afiliado.sitio_web} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-secondary">
                          <i className="fas fa-globe"></i>
                        </a>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card">
              <div className="card-header">
                <h5><i className="fas fa-info-circle me-2"></i>Información de Contacto</h5>
              </div>
              <div className="card-body">
                <p><strong><i className="fas fa-envelope me-2 text-primary"></i>Correo:</strong><br/>{afiliado.correo || 'No especificado'}</p>
                <p><strong><i className="fas fa-phone me-2 text-success"></i>Teléfono:</strong><br/>{afiliado.telefono || 'No especificado'}</p>
                <p><strong><i className="fas fa-building me-2 text-info"></i>Agencia:</strong><br/>{inmobiliariaNombre}</p>
                <p><strong><i className="fas fa-briefcase me-2 text-warning"></i>Años de experiencia:</strong><br/>{afiliado.anos_experiencia || 'No especificado'}</p>
                {afiliado.biografia && (
                  <div className="mt-3">
                    <strong><i className="fas fa-user-tie me-2 text-secondary"></i>Biografía:</strong>
                    <p className="text-muted mt-2">{afiliado.biografia}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card">
              <div className="card-header">
                <h5><i className="fas fa-chart-bar me-2"></i>Estadísticas</h5>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <span><i className="fas fa-star text-warning me-2"></i><strong>Calificación:</strong></span>
                  <span className="badge bg-info fs-6">{promedioCalificacion !== 'N/A' ? `${promedioCalificacion}/5` : promedioCalificacion}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <span><i className="fas fa-comment-dots text-primary me-2"></i><strong>Reseñas:</strong></span>
                  <span className="badge bg-primary fs-6">{reseñas.length}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <span><i className="fas fa-graduation-cap text-success me-2"></i><strong>Talleres Asistidos:</strong></span>
                  <span className="badge bg-success fs-6">{talleresCompletados}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span><i className="fas fa-award text-danger me-2"></i><strong>Créditos:</strong></span>
                  <span className="badge bg-danger fs-6">{creditos}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h5><i className="fas fa-home me-2"></i>Propiedades Vinculadas</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-2">
                    <div className="card text-center bg-primary text-white">
                      <div className="card-body">
                        <h4>{propiedades.length}</h4>
                        <p className="mb-0">Total</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="card text-center bg-success text-white">
                      <div className="card-body">
                        <h4>{propiedades.filter((p: any) => p.estatus_publicacion === 'aprobada').length}</h4>
                        <p className="mb-0">Aprobadas</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="card text-center bg-warning text-white">
                      <div className="card-body">
                        <h4>{propiedades.filter((p: any) => p.estatus_publicacion === 'pendiente').length}</h4>
                        <p className="mb-0">Pendientes</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="card text-center bg-info text-white">
                      <div className="card-body">
                        <h4>{propiedades.filter((p: any) => (p.estado || p.estatus) === 'A' || (p.estado || p.estatus) === 'Disponible').length}</h4>
                        <p className="mb-0">Disponibles</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="card text-center bg-danger text-white">
                      <div className="card-body">
                        <h4>{propiedades.filter((p: any) => (p.estado || p.estatus) === 'Vendida').length}</h4>
                        <p className="mb-0">Vendidas</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="card text-center bg-secondary text-white">
                      <div className="card-body">
                        <h4>{propiedades.filter((p: any) => (p.estado || p.estatus) === 'Pendiente').length}</h4>
                        <p className="mb-0">En Proceso</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Lista de Propiedades */}
        {propiedades.length > 0 && (
          <div className="row mt-4">
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="mb-0"><i className="fas fa-list me-2"></i>Lista de Propiedades</h5>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => navigate(`/admin-property?asesorUid=${afiliado.id}`)}
                  >
                    <i className="fas fa-cog me-1"></i>
                    Gestionar Todas
                  </button>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-striped table-hover">
                      <thead>
                        <tr>
                          <th>Título</th>
                          <th>Ubicación</th>
                          <th>Precio</th>
                          <th>Estado</th>
                          <th>Publicación</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {propiedades.slice(0, 10).map((prop: any) => (
                          <tr key={prop.id}>
                            <td>
                              <strong>{prop.titulo || prop.nombre || 'Sin título'}</strong>
                            </td>
                            <td>
                              {prop.direccion?.zona || prop.direccion?.area || prop.ciudad || 'Sin ubicación'}
                            </td>
                            <td>
                              {prop.precio_actual_usd ? (
                                <span className="badge bg-success">
                                  ${prop.precio_actual_usd.toLocaleString()} USD
                                </span>
                              ) : prop.precio_actual_mxn ? (
                                <span className="badge bg-info">
                                  ${prop.precio_actual_mxn.toLocaleString()} MXN
                                </span>
                              ) : (
                                <span className="text-muted">No especificado</span>
                              )}
                            </td>
                            <td>
                              <span className={`badge ${
                                (prop.estado || prop.estatus) === 'Disponible' || (prop.estado || prop.estatus) === 'A' ? 'bg-success' :
                                (prop.estado || prop.estatus) === 'Vendida' ? 'bg-danger' :
                                (prop.estado || prop.estatus) === 'Pendiente' ? 'bg-warning' :
                                'bg-secondary'
                              }`}>
                                {prop.estado || prop.estatus || 'Sin estado'}
                              </span>
                            </td>
                            <td>
                              <span className={`badge ${
                                prop.estatus_publicacion === 'aprobada' ? 'bg-success' :
                                prop.estatus_publicacion === 'pendiente' ? 'bg-warning' :
                                prop.estatus_publicacion === 'rechazada' ? 'bg-danger' :
                                'bg-secondary'
                              }`}>
                                {prop.estatus_publicacion || 'Sin revisar'}
                              </span>
                            </td>
                            <td>
                              <div className="btn-group btn-group-sm" role="group">
                                <button
                                  className="btn btn-outline-info"
                                  onClick={() => navigate(`/view-admin-property/${prop.id}`)}
                                  title="Ver detalles"
                                >
                                  <i className="fas fa-eye"></i>
                                </button>
                                <button
                                  className="btn btn-outline-warning"
                                  onClick={() => navigate(`/edit-property/${prop.id}`)}
                                  title="Editar"
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {propiedades.length > 10 && (
                      <div className="text-center mt-3">
                        <p className="text-muted">
                          Mostrando 10 de {propiedades.length} propiedades.
                          <button
                            className="btn btn-link"
                            onClick={() => navigate(`/admin-property?asesorUid=${afiliado.id}`)}
                          >
                            Ver todas
                          </button>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Talleres y Capacitaciones */}
        {talleres.length > 0 && (
          <div className="row mt-4">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5><i className="fas fa-graduation-cap me-2"></i>Talleres y Capacitaciones</h5>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Taller</th>
                          <th>Estatus</th>
                          <th>Créditos</th>
                          <th>Fecha</th>
                        </tr>
                      </thead>
                      <tbody>
                        {talleres.map((taller: any, index: number) => (
                          <tr key={index}>
                            <td>{taller.nombre || 'Sin nombre'}</td>
                            <td>
                              {getBadge(taller.estatus, getColorEstatus(taller.estatus))}
                            </td>
                            <td>{taller.creditos || 0}</td>
                            <td>
                              {taller.fecha?.toDate?.().toLocaleDateString('es-MX') ||
                               taller.fechaInicio?.toDate?.().toLocaleDateString('es-MX') ||
                               'No disponible'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Reseñas */}
        {reseñas.length > 0 && (
          <div className="row mt-4">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5><i className="fas fa-star me-2"></i>Reseñas Aprobadas</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    {reseñas.slice(0, 6).map((reseña: any, index: number) => (
                      <div key={index} className="col-md-4 mb-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <strong>{reseña.cliente_nombre || 'Cliente'}</strong>
                              <div>
                                {[1, 2, 3, 4, 5].map(star => (
                                  <i
                                    key={star}
                                    className={`fas fa-star ${star <= (reseña.estrellas || 0) ? 'text-warning' : 'text-muted'}`}
                                  ></i>
                                ))}
                              </div>
                            </div>
                            <p className="mb-0">{reseña.comentario || 'Sin comentario'}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Acciones */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h5><i className="fas fa-cogs me-2"></i>Acciones Administrativas</h5>
              </div>
              <div className="card-body">
                <div className="btn-group" role="group">
                  <Link 
                    to={`/agent-page/${afiliado.id}`} 
                    className="btn btn-outline-info"
                  >
                    <i className="fas fa-eye me-2"></i>
                    Ver Perfil Público
                  </Link>
                  <button
                    className="btn btn-outline-warning"
                    onClick={() => navigate(`/editar-afiliado/${afiliado.id}`)}
                  >
                    <i className="fas fa-edit me-2"></i>
                    Editar Perfil
                  </button>
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => navigate(`/admin-property?asesorUid=${afiliado.id}`)}
                  >
                    <i className="fas fa-home me-2"></i>
                    Gestionar Propiedades ({propiedades.length})
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => navigate('/admin-afiliado')}
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    Volver a Lista
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <FooterTop bg="theme-bg" />
      <Footer />
    </>
  );
}